import { create } from 'zustand';
import { THEME_KEY } from '@/config/constants';
import { getItem, setItem } from '@/utils/storage.util';

export type Theme = 'light' | 'dark';

interface UIStore {
  theme: Theme;
  sidebarOpen: boolean;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (isOpen: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  theme: getItem<Theme>(THEME_KEY) || 'light',
  sidebarOpen: true,
  toggleTheme: () =>
    set((state) => {
      const nextTheme = state.theme === 'light' ? 'dark' : 'light';
      setItem(THEME_KEY, nextTheme);
      
      // Update DOM class lists
      if (nextTheme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      
      return { theme: nextTheme };
    }),
  setTheme: (theme) =>
    set(() => {
      setItem(THEME_KEY, theme);
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return { theme };
    }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
}));
